<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file MainNavigationUserLinks.vue is part of event_pass_client.dev.   -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - MainNavigationUserLinks.vue can not be copied and/or distributed          -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.--><!--//User: keni--><!--//Date: 06/03/2018--><!--//Time: 16:13-->

<template>
    <div v-if="urlKey in route.action"
            class="cursor-pointer d-none d-md-flex justify-content-center align-items-center z-index-2"
    >
        <!--<div class=" d-flex justify-content-center align-items-center ">-->
        <!---->
        <!--</div>-->
        <div v-if="user"
                v-on:click="routeAction(route.action.url)"
                class="main-nav--user-actions--link d-flex justify-content-center align-items-center mr-2 z-index-2"
                :title="route.action.title"
        >
            <i class="material-icons md-36"
                    aria-hidden="true"
            >exit_to_app</i>
            <div class="fs-8 mx-auto"><span class="d-none d-lg-inline">{{route.action.title}}</span></div>
        </div>

        <div v-if="user"
                class="main-nav--user-actions--link d-flex justify-content-center align-items-center z-index-2"
                v-on:click="routeAction(route.action.account.url)"
                :title="route.action.account.title"
        >
            <i class="material-icons md-36"
                    aria-hidden="true">account_circle</i>
            <div class="fs-8 mx-auto"><span class="d-none d-lg-inline">{{route.action.account.title}}</span></div>
        </div>

        <!--Login button-->
        <div v-else
                v-on:click="routeAction(route.action.url,route.action.previous)"
                class="main-nav--user-actions--link d-flex justify-content-center align-items-center z-index-2"
                :title="route.action.title"
        >
            <i class="material-icons md-36"
                    aria-hidden="true"
            >perm_identity</i>
            <div class="fs-8 mx-auto"><span class="d-none d-lg-inline">{{route.action.title}}</span></div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "main-navigation-user-links",
		components: {},
		props: ['route', 'user'],
		created() {
		},
		destroyed() {
		},
		mounted() {
			// this.route = JSON.parse(this.route);
			// console.log('this.route', this.route);

		},
		data() {
			return {
				urlKey: 'url'
			}
		},
		methods: {
			routeAction(url, params) {

				let urlCompiled = url;

				if (typeof params !== 'undefined' && params !== null) {
					urlCompiled = url + '?' + params;
				}

				window.location.href = urlCompiled;
			}
		},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/nav/MainNavigationUserLinks.vue